<template>
  <div class="page_content career_list" v-if="permission && permission.version === '5'">

    <div class="page_heading">
      <div class="col-5 module_heading" role="heading" aria-level="1">
        <span class="career_icon fas fa-address-book" style="color: #45a352;"></span>
        <span class="program_guide_title module_type_name">Career Management</span>
      </div>

      <!-- <div class="col-7 btn_container">
        <button class="btn btn-primary" aria-label="upload" :disabled="!permission.institutionPermission.canUploadCareers" @click="goToUploadPage">upload</button>
      </div> -->
    </div>

    <div class="user-management-section">
      <div class="page_subheading">
        <div class="toolbar-right ui-list-toolbar">
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
          <div class="btn_container pagination_sty3">
            <button type="button" :disabled="firstPage" @click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="page_count" aria-hidden="true">{{ page + 1 }}</span>
            <button type="button" :disabled="lastPage" @click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" placeholder="search by name" aria-label="search by name" v-model="searchName" v-on:keyup.enter="searchCareers">
            <button type="button" class="btn btn_srh" @click="searchCareers" aria-label="search careers">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>

		<div class="table_containers pg_list_container">
	        <table v-if="isCareersLoaded" class="table">
	        	<!--
	          	<thead class="thead-light">
	            	<tr>
	              		<th class="first-column">Name</th>
	              		<th class="second-column">Soc Code</th>
	              		<th class="action-column">Action</th>
	            	</tr>
	          	</thead>
	          	-->
				<tbody v-if="formattedCareers && formattedCareers.length > 0">
	            	<tr v-for="career in formattedCareers" class="list_row">
	              		<td class="first-column">
	              			<div style="font-size: 22px; margin-top: 25px;">{{ career.name }}</div>
	              			<div style="font-size: 16px; margin-top: 15px;">Soc Code: {{ career.code }}</div>
	              		</td>

	              		<td class="second-column">
	              			<div class="thumbnail_container" style="float: right; margin-right: 25px;">
	              				<template v-if="!permission.systemPermission.readOnly">
									<b-btn class="icon-pencil" aria-label="edit" tabindex="0" @click="goToEditPage(career)"></b-btn>
	                			</template>
								<img v-if="career.thumbnailURI" class="w-100" v-bind:src="career.thumbnailURI" alt="Img">
								<div v-else class="thumbnail_default ic_career fas fa-address-book"></div>
							</div>
	              		</td>

	            	</tr>
				</tbody>
	          	<tbody v-else class="no-result">
	          		<tr>
				    	<td colspan="6" style="text-align:center;">No Results Found</td>
			     	</tr>
	          	</tbody>
			</table>
		</div>

	</div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
import '../../../assets/module/css/user/userList.min.css'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'career-list',
  data () {
    return {
      pageSize: 10,
      sizeOptions: [ 10, 50, 100 ],
      firstPage: true,
      lastPage: false,
      page: 0,
      totalPages: 0,
      totalElements: 0,
      careers: [],
      isCareersLoaded: false,
      careerDeleteMessage: '',
      careerToBeDeleted: {},
      searchName: ''
    }
  },

  mounted () {
    this.loadPermission().then(res => {
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.loadCareerList()
      }, 500)
    })
  },
  methods: {
    ...mapActions([
      'loadCareers',
      'loadPermission'
    ]),
    loadCareerList () {
      this.loadCareers({page: this.page, count: this.pageSize, name: this.searchName}).then(result => {
        result = result && result.length > 0 ? result[0] : result
        this.careers = result.content
        this.page = result.number
        // latest Spring library changed Page.java fields from firstPage -> first and lastPage -> last
        this.firstPage = (result.first || result.firstPage) ? (result.first || result.firstPage) : false
        this.lastPage = (result.last || result.lastPage) ? (result.last || result.lastPage) : false
        this.totalPages = result.totalPages
        this.totalElements = result.totalElements
        this.isCareersLoaded = true
        this.$refs.loadingModal.hide()
      })
      this.$forceUpdate()
    },
    goToUploadPage () {
      return this.$router.push({name: 'careerUpload'})
    },
    goToEditPage (career) {
      return this.$router.push({ name: 'editCareer', params: { code: career.code, loadDataFromServer: true } })
    },
    searchCareers () {
      this.page = 0
      this.loadCareerList()
    },
    resetPage () {
      this.page = 0
      this.loadCareerList()
    },
    prev () {
      this.page = this.page - 1
      this.loadCareerList()
    },
    next () {
      this.page = this.page + 1
      this.loadCareerList()
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission
    }),
    formattedCareers () {
      let careers = this.careers
      if (!careers || careers.length === 0) {
        return []
      }
      careers.forEach(career => {
        console.log('career: ', career)
      })
      return careers
    }
  }
}
</script>

<style scoped>
.career_icon {
  float:left;
  width:30px;
  font-size:30px;
  color:#34b2ff;
  margin:3px 3px 0 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerList.vue